import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: grid;
  padding: 20px 32px 32px;
  grid-template-columns: 1fr 292px;
  grid-template-rows: repeat(6, 84.88px);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  overflow: auto;

  > div:nth-child(1) {
    grid-area: 1 / 2 / 3 / 3;
  }

  > div:nth-child(2) {
    grid-area: 1 / 1 / 2 / 2;
  }

  > div:nth-child(3) {
    grid-area: 2 / 1 / 3 / 2;
  }

  > div:nth-child(4) {
    grid-area: 3 / 1 / 5 / 2;
  }

  > div:nth-child(5) {
    grid-area: 3 / 2 / 4 / 3;
  }

  > div:nth-child(6) {
    grid-area: 4 / 2 / 5 / 3;
  }

  > div:nth-child(7) {
    grid-area: 5 / 2 / 6 / 3;
  }

  > div:nth-child(8) {
    grid-area: 5 / 1 / 6 / 2;
  }

  > div:nth-child(9) {
    grid-area: 6 / 1 / 7 / 3;
  }

  @media only screen and (max-width: 768px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    > div:nth-child(1) {
      height: 196px;
      max-height: 196px;
    }

    > div:nth-child(4) {
      order: 9;
      height: 150px;
    }
  }
`;
